<template>
  <div id="paginabilanciCoccia">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Bilancio Coccia</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropAnni" ref="dropAnni" :query="queryAnni" :dataSource="anniData"
                  :index="anniIndex" :fields="anniFields" :change="onAnnoChange" v-model="annoCorrente"
                  placeholder="Seleziona un Anno"></ejs-dropdownlist>
              </b-col>

              <b-col xl="12" md="12" class="text-right mt-1" v-show="showButtonCreateBilancio">
                <ejs-button id="creaBilancioCocciaButton" cssClass="e-flat"
                  @click.native="creaBilancioCocciaButton()">CREA BILANCIO COCCIA PER L'ANNO SELEZIONATO
                </ejs-button>
              </b-col>

              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col xl="12" md="12" class="pt-1">
        <div id="TabParent">
          <b-tabs ref="tabA" v-model="tabAIndex" v-show="showTabsBilancio">
            <b-tab title="BILANCIO COCCIA PREVENTIVO" @click="tabClicked('tab01')">
              <b-row class="match-height">
                <b-col xl="12" md="12">
                  <h3>&nbsp</h3>
                  <h3>ENTRATE BILANCIO PREVENTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Entrate</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviBiglProd" class="h5">RICAVI BIGLIETTERIA PRODUZIONI</label>
                          <ejs-numerictextbox id="prevRicaviBiglProd" v-model="bilancioCocciaActiveData.prevRicaviBiglProd"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI BIGLIETTERIA PRODUZIONI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviBiglCompOsp" class="h5">RICAVI BIGLIETTERIA COMPAGNIE OSPITI</label>
                          <ejs-numerictextbox id="prevRicaviBiglCompOsp" v-model="bilancioCocciaActiveData.prevRicaviBiglCompOsp"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="RICAVI BIGLIETTERIA COMPAGNIE OSPITI" showSpinButton="false"
                                              showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviCoprodSpett" class="h5">RICAVI PER COPRODUZIONI SPETTACOLI</label>
                          <ejs-numerictextbox id="prevRicaviCoprodSpett" v-model="bilancioCocciaActiveData.prevRicaviCoprodSpett"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="RICAVI PER COPRODUZIONI SPETTACOLI" showSpinButton="false"
                                              showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviAccademiaCantoDir" class="h5">RICAVI PER ACCADEMIA - CANTO E DIREZIONE</label>
                          <ejs-numerictextbox id="prevRicaviAccademiaCantoDir"
                            v-model="bilancioCocciaActiveData.prevRicaviAccademiaCantoDir" floatLabelType="Never"
                            cssClass="" format="€ ###.##" placeholder="RICAVI PER ACCADEMIA - CANTO E DIREZIONE"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviPrestServizi" class="h5">RICAVI DA PRESTAZIONI DI SERVIZI</label>
                          <ejs-numerictextbox id="prevRicaviPrestServizi" v-model="bilancioCocciaActiveData.prevRicaviPrestServizi"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA PRESTAZIONI DI SERVIZI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviSponsor" class="h5">RICAVI DA SPONSOR</label>
                          <ejs-numerictextbox id="prevRicaviSponsor" v-model="bilancioCocciaActiveData.prevRicaviSponsor"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA SPONSOR"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviProgetti" class="h5">RICAVI DA PROGETTI</label>
                          <ejs-numerictextbox id="prevRicaviProgetti" v-model="bilancioCocciaActiveData.prevRicaviProgetti"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA PROGETTI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviMinistero" class="h5">RICAVI DA MINISTERO</label>
                          <ejs-numerictextbox id="prevRicaviMinistero" v-model="bilancioCocciaActiveData.prevRicaviMinistero"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA MINISTERO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviRegPiemonte" class="h5">RICAVI DA REGIONE PIEMONTE</label>
                          <ejs-numerictextbox id="prevRicaviRegPiemonte" v-model="bilancioCocciaActiveData.prevRicaviRegPiemonte"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA REGIONE PIEMONTE"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviComNovaraOrd" class="h5">RICAVI DA COMUNE DI NOVARA</label>
                          <ejs-numerictextbox id="prevRicaviComNovaraOrd" v-model="bilancioCocciaActiveData.prevRicaviComNovaraOrd"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA COMUNE DI NOVARA"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviComNovaraExtra" class="h5">RICAVI DA COMUNE DI NOVARA - CONTRIBUTO
                            EXTRA</label>
                          <ejs-numerictextbox id="prevRicaviComNovaraExtra" v-model="bilancioCocciaActiveData.prevRicaviComNovaraExtra"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="RICAVI DA COMUNE DI NOVARA - CONTRIBUTO EXTRA" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviFondBPM" class="h5">RICAVI DA FONDAZIONE BPM</label>
                          <ejs-numerictextbox id="prevRicaviFondBPM" v-model="bilancioCocciaActiveData.prevRicaviFondBPM"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA FONDAZIONE BPM"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviFondCRT" class="h5">RICAVI DA FONDAZIONE CRT</label>
                          <ejs-numerictextbox id="prevRicaviFondCRT" v-model="bilancioCocciaActiveData.prevRicaviFondCRT"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA FONDAZIONE CRT"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRicaviCCIAA" class="h5">RICAVI DA CCIAA</label>
                          <ejs-numerictextbox id="prevRicaviCCIAA" v-model="bilancioCocciaActiveData.prevRicaviCCIAA"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA CCIAA"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevContrArtBonus" class="h5">CONTRIBUTI ART BONUS</label>
                          <ejs-numerictextbox id="prevContrArtBonus" v-model="bilancioCocciaActiveData.prevContrArtBonus"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CONTRIBUTI ART BONUS"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevProventiDonazioni" class="h5">PROVENTI DA DONAZIONI</label>
                          <ejs-numerictextbox id="prevProventiDonazioni" v-model="bilancioCocciaActiveData.prevProventiDonazioni"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="PROVENTI DA DONAZIONI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAffittiAttivi" class="h5">AFFITTI ATTIVI</label>
                          <ejs-numerictextbox id="prevAffittiAttivi" v-model="bilancioCocciaActiveData.prevAffittiAttivi"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="AFFITTI ATTIVI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>

                        <b-col xl="12" md="12" class="mb-2">
                          <label for="prevTotaleEntrate" class="h5">TOTALE ENTRATE BILANCIO PREVENTIVO</label>
                          <ejs-numerictextbox id="prevTotaleEntrate" v-model="prevTotaleEntrate" floatLabelType="Never"
                            cssClass="" format="€ ###.##" placeholder="Totale Entrate" showSpinButton="false"
                            showClearButton="true" :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>USCITE BILANCIO PREVENTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Uscite</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAcquistiMatScene" class="h5">ACQUISTI MATERIALI PER SCENE</label>
                          <ejs-numerictextbox id="prevAcquistiMatScene" v-model="bilancioCocciaActiveData.prevAcquistiMatScene"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ACQUISTI MATERIALI PER SCENE"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAcquistiMatConsumo" class="h5">ACQUISTI MATERIALE DI CONSUMO</label>
                          <ejs-numerictextbox id="prevAcquistiMatConsumo" v-model="bilancioCocciaActiveData.prevAcquistiMatConsumo"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ACQUISTI MATERIALE DI CONSUMO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevDispositiviProtCovid" class="h5">DISPOSITIVI DI PROTEZIONE COVID19</label>
                          <ejs-numerictextbox id="prevDispositiviProtCovid" v-model="bilancioCocciaActiveData.prevDispositiviProtCovid"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="DISPOSITIVI DI PROTEZIONE COVID19" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAttrInf516Eur" class="h5">ATTREZZATURA inf. 516 EURO DA NON AMM.RE</label>
                          <ejs-numerictextbox id="prevAttrInf516Eur" v-model="bilancioCocciaActiveData.prevAttrInf516Eur"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="ATTREZZATURA inf. 516 EURO DA NON AMM.RE" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCellulariDed80inf516Eur" class="h5">ACQUISTO CELLULARI DED 80% inf. 516 € DA
                            NON AMM.RE</label>
                          <ejs-numerictextbox id="prevCellulariDed80inf516Eur" v-model="bilancioCocciaActiveData.prevCellulariDed80inf516Eur"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="ACQUISTO CELLULARI DED 80% inf. 516 € DA NON AMM.RE" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCarbLubrMezziTrasp" class="h5">CARBURANTI E LUBRIFICANTI PER MEZZI DI
                            TRASPORTO</label>
                          <ejs-numerictextbox id="prevCarbLubrMezziTrasp" v-model="bilancioCocciaActiveData.prevCarbLubrMezziTrasp"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="CARBURANTI E LUBRIFICANTI PER MEZZI DI TRASPORTO" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAcquistoMatPubbl" class="h5">ACQUISTO MATERIALE PUBBLICITARIO</label>
                          <ejs-numerictextbox id="prevAcquistoMatPubbl" v-model="bilancioCocciaActiveData.prevAcquistoMatPubbl"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ACQUISTO MATERIALE PUBBLICITARIO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCancelleria" class="h5">CANCELLERIA</label>
                          <ejs-numerictextbox id="prevCancelleria" v-model="bilancioCocciaActiveData.prevCancelleria"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CANCELLERIA"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevMatPulizia" class="h5">MATERIALE DI PULIZIA</label>
                          <ejs-numerictextbox id="prevMatPulizia" v-model="bilancioCocciaActiveData.prevMatPulizia"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="MATERIALE DI PULIZIA"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAcquistoFarmaci" class="h5">ACQUISTO DI FARMACI</label>
                          <ejs-numerictextbox id="prevAcquistoFarmaci" v-model="bilancioCocciaActiveData.prevAcquistoFarmaci"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ACQUISTO DI FARMACI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSpeseVittoAlloggio" class="h5">SPESE VITTO, ALLOGGIO</label>
                          <ejs-numerictextbox id="prevSpeseVittoAlloggio" v-model="bilancioCocciaActiveData.prevSpeseVittoAlloggio"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SPESE VITTO, ALLOGGIO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSpeseViaggioTrasfertaDip" class="h5">SPESE DI VIAGGIO E TRASFERTA
                            DIPENDENTI</label>
                          <ejs-numerictextbox id="prevSpeseViaggioTrasfertaDip" v-model="bilancioCocciaActiveData.prevSpeseViaggioTrasfertaDip"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="SPESE DI VIAGGIO E TRASFERTA DIPENDENTI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevOpereServiziGenerDip" class="h5">OPERE E SERVIZI PER LA GENERALITA' DEI
                            DIPENDENTI</label>
                          <ejs-numerictextbox id="prevOpereServiziGenerDip" v-model="bilancioCocciaActiveData.prevOpereServiziGenerDip"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="OPERE E SERVIZI PER LA GENERALITA' DEI DIPENDENTI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevPedaggiAutostr" class="h5">PEDAGGI AUTOSTRADALI</label>
                          <ejs-numerictextbox id="prevPedaggiAutostr"
                            v-model="bilancioCocciaActiveData.prevPedaggiAutostr" floatLabelType="Never" cssClass=""
                            format="€ ###.##" placeholder="PEDAGGI AUTOSTRADALI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSpesePubblicita" class="h5">SPESE DI PUBBLICITA'</label>
                          <ejs-numerictextbox id="prevSpesePubblicita" v-model="bilancioCocciaActiveData.prevSpesePubblicita"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SPESE DI PUBBLICITA'"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevEnergiaElettrica" class="h5">ENERGIA ELETTRICA</label>
                          <ejs-numerictextbox id="prevEnergiaElettrica" v-model="bilancioCocciaActiveData.prevEnergiaElettrica"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ENERGIA ELETTRICA"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevConsulenzeTecniche" class="h5">CONSULENZE TECNICHE</label>
                          <ejs-numerictextbox id="prevConsulenzeTecniche" v-model="bilancioCocciaActiveData.prevConsulenzeTecniche"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CONSULENZE TECNICHE"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevServiziVigilAntinc" class="h5">SERVIZI VIGILANZA ANTINCENDIO</label>
                          <ejs-numerictextbox id="prevServiziVigilAntinc" v-model="bilancioCocciaActiveData.prevServiziVigilAntinc"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SERVIZI VIGILANZA ANTINCENDIO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevManutRiparAutomezzi" class="h5">MANUTENZIONI E RIPARAZIONI AUTOMEZZI</label>
                          <ejs-numerictextbox id="prevManutRiparAutomezzi" v-model="bilancioCocciaActiveData.prevManutRiparAutomezzi"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="MANUTENZIONI E RIPARAZIONI AUTOMEZZI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSpeseRecupCrediti" class="h5">SPESE PER RECUPERO CREDITI</label>
                          <ejs-numerictextbox id="prevSpeseRecupCrediti" v-model="bilancioCocciaActiveData.prevSpeseRecupCrediti"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SPESE PER RECUPERO CREDITI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAssicDiverseNonObbl" class="h5">ASSICURAZIONI DIVERSE NON OBBLIGATORIE</label>
                          <ejs-numerictextbox id="prevAssicDiverseNonObbl" v-model="bilancioCocciaActiveData.prevAssicDiverseNonObbl"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="ASSICURAZIONI DIVERSE NON OBBLIGATORIE" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSpeseServPostali" class="h5">SPESE PER SERVIZI POSTALI</label>
                          <ejs-numerictextbox id="prevSpeseServPostali" v-model="bilancioCocciaActiveData.prevSpeseServPostali"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SPESE PER SERVIZI POSTALI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevServPulizia" class="h5">SERVIZI DI PULIZIA</label>
                          <ejs-numerictextbox id="prevServPulizia" v-model="bilancioCocciaActiveData.prevServPulizia"
                            floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SERVIZI DI PULIZIA"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAcqua" class="h5">ACQUA</label>
                          <ejs-numerictextbox id="prevAcqua" v-model="bilancioCocciaActiveData.prevAcqua"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ACQUA" showSpinButton="false"
                                              showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSpeseFormazAntincPrSocc" class="h5">SPESE FORMAZIONE ANTINCENDIO E PRONTO
                            SOCCORSO</label>
                          <ejs-numerictextbox id="prevSpeseFormazAntincPrSocc" v-model="bilancioCocciaActiveData.prevSpeseFormazAntincPrSocc"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="SPESE FORMAZIONE ANTINCENDIO E PRONTO SOCCORSO" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevServiziDiTerzi" class="h5">SERVIZI DI TERZI (SERVIZI DI SALA, SEGRETARIATO,
                            FACCHINAGGIO)</label>
                          <ejs-numerictextbox id="prevServiziDiTerzi" v-model="bilancioCocciaActiveData.prevServiziDiTerzi"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="SERVIZI DI TERZI (SERVIZI DI SALA, SEGRETARIATO, FACCHINAGGIO)"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevConsulAmmLegali" class="h5">CONSULENZE AMMINISTRATIVE E LEGALI</label>
                          <ejs-numerictextbox id="prevConsulAmmLegali" v-model="bilancioCocciaActiveData.prevConsulAmmLegali"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="CONSULENZE AMMINISTRATIVE E LEGALI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevTelefoniche" class="h5">TELEFONICHE </label>
                          <ejs-numerictextbox id="prevTelefoniche" v-model="bilancioCocciaActiveData.prevTelefoniche"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="TELEFONICHE "
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSpeseElaborPaghe" class="h5">SPESE ELABORAZIONE PAGHE</label>
                          <ejs-numerictextbox id="prevSpeseElaborPaghe" v-model="bilancioCocciaActiveData.prevSpeseElaborPaghe"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SPESE ELABORAZIONE PAGHE"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevManutRiparazioni" class="h5">MANUTENZIONI E RIPARAZIONI</label>
                          <ejs-numerictextbox id="prevManutRiparazioni" v-model="bilancioCocciaActiveData.prevManutRiparazioni"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="MANUTENZIONI E RIPARAZIONI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevManutAContratto" class="h5">MANUTENZIONI A CONTRATTO</label>
                          <ejs-numerictextbox id="prevManutAContratto" v-model="bilancioCocciaActiveData.prevManutAContratto"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="MANUTENZIONI A CONTRATTO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRiscaldamento" class="h5">RISCALDAMENTO</label>
                          <ejs-numerictextbox id="prevRiscaldamento" v-model="bilancioCocciaActiveData.prevRiscaldamento"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RISCALDAMENTO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevServBancari" class="h5">SERVIZI BANCARI</label>
                          <ejs-numerictextbox id="prevServBancari" v-model="bilancioCocciaActiveData.prevServBancari"
                            floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SERVIZI BANCARI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCostiServiziRifiuti" class="h5">COSTI PER SERVIZI SU RIFIUTI</label>
                          <ejs-numerictextbox id="prevCostiServiziRifiuti"
                            v-model="bilancioCocciaActiveData.prevCostiServiziRifiuti" floatLabelType="Never"
                            cssClass="" format="€ ###.##" placeholder="COSTI PER SERVIZI SU RIFIUTI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAssicDiverseObbl" class="h5">ASSICURAZIONI DIVERSE OBBLIGATORIE</label>
                          <ejs-numerictextbox id="prevAssicDiverseObbl" v-model="bilancioCocciaActiveData.prevAssicDiverseObbl"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="ASSICURAZIONI DIVERSE OBBLIGATORIE" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCanoniAssistSoftware" class="h5">CANONI ASSISTENZA SOFTWARE</label>
                          <ejs-numerictextbox id="prevCanoniAssistSoftware" v-model="bilancioCocciaActiveData.prevCanoniAssistSoftware"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CANONI ASSISTENZA SOFTWARE"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevServiziInternet" class="h5">SERVIZI RELATIVI A INTERNET</label>
                          <ejs-numerictextbox id="prevServiziInternet" v-model="bilancioCocciaActiveData.prevServiziInternet"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SERVIZI RELATIVI A INTERNET"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevViaggioTrasfCollaboratori" class="h5">VIAGGIO E TRASFERTE
                            COLLABORATORI</label>
                          <ejs-numerictextbox id="prevViaggioTrasfCollaboratori" v-model="bilancioCocciaActiveData.prevViaggioTrasfCollaboratori"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="VIAGGIO E TRASFERTE COLLABORATORI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevScene" class="h5">SCENE</label>
                          <ejs-numerictextbox id="prevScene" v-model="bilancioCocciaActiveData.prevScene"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SCENE" showSpinButton="false"
                                              showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCostumi" class="h5">COSTUMI</label>
                          <ejs-numerictextbox id="prevCostumi" v-model="bilancioCocciaActiveData.prevCostumi"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="COSTUMI" showSpinButton="false"
                                              showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCoro" class="h5">CORO</label>
                          <ejs-numerictextbox id="prevCoro" v-model="bilancioCocciaActiveData.prevCoro"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CORO" showSpinButton="false"
                                              showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevOrchestra" class="h5">ORCHESTRA</label>
                          <ejs-numerictextbox id="prevOrchestra" v-model="bilancioCocciaActiveData.prevOrchestra"
                            floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ORCHESTRA"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevTrasporti" class="h5">TRASPORTI</label>
                          <ejs-numerictextbox id="prevTrasporti" v-model="bilancioCocciaActiveData.prevTrasporti"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="TRASPORTI" showSpinButton="false"
                                              showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCollabProfessTecnici" class="h5">COLLABORATORI PROFESSIONISTI TECNICI</label>
                          <ejs-numerictextbox id="prevCollabProfessTecnici" v-model="bilancioCocciaActiveData.prevCollabProfessTecnici"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="COLLABORATORI PROFESSIONISTI TECNICI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCollabArtistici" class="h5">COLLABORATORI ARTISTICI</label>
                          <ejs-numerictextbox id="prevCollabArtistici" v-model="bilancioCocciaActiveData.prevCollabArtistici"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="COLLABORATORI ARTISTICI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAllestimenti" class="h5">ALLESTIMENTI</label>
                          <ejs-numerictextbox id="prevAllestimenti" v-model="bilancioCocciaActiveData.prevAllestimenti"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ALLESTIMENTI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevNoloPartiture" class="h5">NOLO PARTITURE</label>
                          <ejs-numerictextbox id="prevNoloPartiture" v-model="bilancioCocciaActiveData.prevNoloPartiture"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="NOLO PARTITURE"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevVittoAlloggioArtisti" class="h5">VITTO E ALLOGGIO ARTISTI</label>
                          <ejs-numerictextbox id="prevVittoAlloggioArtisti" v-model="bilancioCocciaActiveData.prevVittoAlloggioArtisti"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="VITTO E ALLOGGIO ARTISTI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCachetCompOspiti1" class="h5">CACHET COMPAGNIE OSPITI 1</label>
                          <ejs-numerictextbox id="prevCachetCompOspiti1" v-model="bilancioCocciaActiveData.prevCachetCompOspiti1"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CACHET COMPAGNIE OSPITI 1"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCoproduzioni" class="h5">COPRODUZIONI</label>
                          <ejs-numerictextbox id="prevCoproduzioni" v-model="bilancioCocciaActiveData.prevCoproduzioni"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="COPRODUZIONI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCachetCompOspiti2" class="h5">CACHET COMPAGNIE OSPITI 2</label>
                          <ejs-numerictextbox id="prevCachetCompOspiti2" v-model="bilancioCocciaActiveData.prevCachetCompOspiti2"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CACHET COMPAGNIE OSPITI 2"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevDocenti" class="h5">DOCENTI</label>
                          <ejs-numerictextbox id="prevDocenti" v-model="bilancioCocciaActiveData.prevDocenti"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="DOCENTI" showSpinButton="false"
                                              showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCollArtisticiAMO" class="h5">COLL ARTISTICI AMO</label>
                          <ejs-numerictextbox id="prevCollArtisticiAMO" v-model="bilancioCocciaActiveData.prevCollArtisticiAMO"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="COLL ARTISTICI AMO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevServDigitalizz" class="h5">SERVIZI DI DIGITALIZZAZIONE</label>
                          <ejs-numerictextbox id="prevServDigitalizz" v-model="bilancioCocciaActiveData.prevServDigitalizz"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SERVIZI DI DIGITALIZZAZIONE"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevNoleggioSceneCostumi" class="h5">NOLEGGIO SCENE E COSTUMI</label>
                          <ejs-numerictextbox id="prevNoleggioSceneCostumi" v-model="bilancioCocciaActiveData.prevNoleggioSceneCostumi"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="NOLEGGIO SCENE E COSTUMI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevNoleggioMatTecnico" class="h5">NOLEGGIO MATERIALE TECNICO</label>
                          <ejs-numerictextbox id="prevNoleggioMatTecnico" v-model="bilancioCocciaActiveData.prevNoleggioMatTecnico"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="NOLEGGIO MATERIALE TECNICO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAffittiLocPassImmob" class="h5">AFFITTI E LOCAZIONI PASSIVE IMMOBILI</label>
                          <ejs-numerictextbox id="prevAffittiLocPassImmob" v-model="bilancioCocciaActiveData.prevAffittiLocPassImmob"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="AFFITTI E LOCAZIONI PASSIVE IMMOBILI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCanoniNolMacchUff" class="h5">CANONI NOLEGGIO MACCHINE D'UFFICIO</label>
                          <ejs-numerictextbox id="prevCanoniNolMacchUff" v-model="bilancioCocciaActiveData.prevCanoniNolMacchUff"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="CANONI NOLEGGIO MACCHINE D'UFFICIO" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevNoleggioAutomezzi" class="h5">NOLEGGIO AUTOMEZZI</label>
                          <ejs-numerictextbox id="prevNoleggioAutomezzi" v-model="bilancioCocciaActiveData.prevNoleggioAutomezzi"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="NOLEGGIO AUTOMEZZI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAggSWLicUso" class="h5">AGGIORNAMENTO SOFTWARE E LICENZE D'USO</label>
                          <ejs-numerictextbox id="prevAggSWLicUso" v-model="bilancioCocciaActiveData.prevAggSWLicUso"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="AGGIORNAMENTO SOFTWARE E LICENZE D'USO" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAffittiLocazioni" class="h5">AFFITTI E LOCAZIONI</label>
                          <ejs-numerictextbox id="prevAffittiLocazioni" v-model="bilancioCocciaActiveData.prevAffittiLocazioni"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="AFFITTI E LOCAZIONI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevLeasingFinanziario" class="h5">LEASING FINANZIARIO (AMPLIAMENTO RETE WIFI, PC
                            UFFICI, ETC.)</label>
                          <ejs-numerictextbox id="prevLeasingFinanziario" v-model="bilancioCocciaActiveData.prevLeasingFinanziario"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="LEASING FINANZIARIO (AMPLIAMENTO RETE WIFI, PC UFFICI, ETC.)"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRoyaltiesDirAutBrevetti" class="h5">ROYALTIES, DIRITTI D'AUTORE E
                            BREVETTI</label>
                          <ejs-numerictextbox id="prevRoyaltiesDirAutBrevetti" v-model="bilancioCocciaActiveData.prevRoyaltiesDirAutBrevetti"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="ROYALTIES, DIRITTI D'AUTORE E BREVETTI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSalariStipendi" class="h5">SALARI E STIPENDI</label>
                          <ejs-numerictextbox id="prevSalariStipendi" v-model="bilancioCocciaActiveData.prevSalariStipendi"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SALARI E STIPENDI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevContrPrevidImpiegTecnici" class="h5">CONTRIBUTI PREVIDENZIALI IMPIEGATI
                            TECNICI</label>
                          <ejs-numerictextbox id="prevContrPrevidImpiegTecnici" v-model="bilancioCocciaActiveData.prevContrPrevidImpiegTecnici"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="CONTRIBUTI PREVIDENZIALI IMPIEGATI TECNICI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevContribEnpalsArtisti" class="h5">CONTRIBUTI ENPALS ARTISTI</label>
                          <ejs-numerictextbox id="prevContribEnpalsArtisti" v-model="bilancioCocciaActiveData.prevContribEnpalsArtisti"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CONTRIBUTI ENPALS ARTISTI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevContrInail" class="h5">CONTRIBUTI INAIL</label>
                          <ejs-numerictextbox id="prevContrInail" v-model="bilancioCocciaActiveData.prevContrInail"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CONTRIBUTI INAIL"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevOneriSociali" class="h5">ONERI SOCIALI</label>
                          <ejs-numerictextbox id="prevOneriSociali" v-model="bilancioCocciaActiveData.prevOneriSociali"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ONERI SOCIALI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevTrattamFineRapp" class="h5">TRATTAMENTO DI FINE RAPPORTO</label>
                          <ejs-numerictextbox id="prevTrattamFineRapp" v-model="bilancioCocciaActiveData.prevTrattamFineRapp"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="TRATTAMENTO DI FINE RAPPORTO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAmmortImmobilizImmat" class="h5">AMMORTAMENTO DELLE IMMOBILIZZAZIONI
                            IMMATERIALI</label>
                          <ejs-numerictextbox id="prevAmmortImmobilizImmat" v-model="bilancioCocciaActiveData.prevAmmortImmobilizImmat"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="AMMORTAMENTO DELLE IMMOBILIZZAZIONI IMMATERIALI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAmmortBeniMat" class="h5">AMMORTAMENTO BENI MATERIALI</label>
                          <ejs-numerictextbox id="prevAmmortBeniMat" v-model="bilancioCocciaActiveData.prevAmmortBeniMat"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="AMMORTAMENTO BENI MATERIALI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevBeniOmaggEccOmaggi" class="h5">BENI OMAGGIO E ECCEDENZA OMAGGI</label>
                          <ejs-numerictextbox id="prevBeniOmaggEccOmaggi" v-model="bilancioCocciaActiveData.prevBeniOmaggEccOmaggi"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="BENI OMAGGIO E ECCEDENZA OMAGGI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevIMU" class="h5">IMU</label>
                          <ejs-numerictextbox id="prevIMU" v-model="bilancioCocciaActiveData.prevIMU"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="IMU" showSpinButton="false"
                                              showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevImpostaRegistro" class="h5">IMPOSTA DI REGISTRO</label>
                          <ejs-numerictextbox id="prevImpostaRegistro" v-model="bilancioCocciaActiveData.prevImpostaRegistro"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="IMPOSTA DI REGISTRO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevTARI" class="h5">TARI</label>
                          <ejs-numerictextbox id="prevTARI" v-model="bilancioCocciaActiveData.prevTARI"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="TARI" showSpinButton="false"
                                              showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSopravvPassive" class="h5">SOPRAVVENIENZE PASSIVE </label>
                          <ejs-numerictextbox id="prevSopravvPassive" v-model="bilancioCocciaActiveData.prevSopravvPassive"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SOPRAVVENIENZE PASSIVE "
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevBolliValBollati" class="h5">BOLLI E VALORI BOLLATI</label>
                          <ejs-numerictextbox id="prevBolliValBollati" v-model="bilancioCocciaActiveData.prevBolliValBollati"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="BOLLI E VALORI BOLLATI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevQuoteAssocContribAssoc" class="h5">QUOTE ASSOCIATIVE/CONTRIBUTI
                            ASSOCIATIVI</label>
                          <ejs-numerictextbox id="prevQuoteAssocContribAssoc" v-model="bilancioCocciaActiveData.prevQuoteAssocContribAssoc"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="QUOTE ASSOCIATIVE/CONTRIBUTI ASSOCIATIVI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevDirittiSIAE" class="h5">DIRITTI SIAE</label>
                          <ejs-numerictextbox id="prevDirittiSIAE" v-model="bilancioCocciaActiveData.prevDirittiSIAE"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="DIRITTI SIAE"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSopravvPassEsPrec" class="h5">SOPRAVV PASSIVE ESERC PRECEDENTI</label>
                          <ejs-numerictextbox id="prevSopravvPassEsPrec" v-model="bilancioCocciaActiveData.prevSopravvPassEsPrec"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SOPRAVV PASSIVE ESERC PRECEDENTI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSanzTribRavvOpInded" class="h5">SANZIONI TRIBUTARIE DA RAVVED. OPEROSO
                            INDEDUCIBILI</label>
                          <ejs-numerictextbox id="prevSanzTribRavvOpInded" v-model="bilancioCocciaActiveData.prevSanzTribRavvOpInded"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="SANZIONI TRIBUTARIE DA RAVVED. OPEROSO INDEDUCIBILI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAltriProvFinanz" class="h5">ALTRI PROVENTI FINANZIARI</label>
                          <ejs-numerictextbox id="prevAltriProvFinanz" v-model="bilancioCocciaActiveData.prevAltriProvFinanz"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ALTRI PROVENTI FINANZIARI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevOneriBancFinanz" class="h5">ONERI BANCARI FINANZIARI</label>
                          <ejs-numerictextbox id="prevOneriBancFinanz" v-model="bilancioCocciaActiveData.prevOneriBancFinanz"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ONERI BANCARI FINANZIARI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevInterPassContoCorr" class="h5">INTERESSI PASSIVI DI CONTO CORRENTE</label>
                          <ejs-numerictextbox id="prevInterPassContoCorr" v-model="bilancioCocciaActiveData.prevInterPassContoCorr"
                                              floatLabelType="Never" cssClass="" format="€ ###.##"
                                              placeholder="INTERESSI PASSIVI DI CONTO CORRENTE" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevInterPassiviMutui" class="h5">INTERESSI PASSIVI SU MUTUI</label>
                          <ejs-numerictextbox id="prevInterPassiviMutui" v-model="bilancioCocciaActiveData.prevInterPassiviMutui"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="INTERESSI PASSIVI SU MUTUI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevInterPassiviMora" class="h5">INTERESSI PASSIVI DI MORA</label>
                          <ejs-numerictextbox id="prevInterPassiviMora" v-model="bilancioCocciaActiveData.prevInterPassiviMora"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="INTERESSI PASSIVI DI MORA"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevProvOneriFinanz" class="h5">PROVENTI E ONERI FINANZIARI</label>
                          <ejs-numerictextbox id="prevProvOneriFinanz" v-model="bilancioCocciaActiveData.prevProvOneriFinanz"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="PROVENTI E ONERI FINANZIARI"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevImposteReddEserc" class="h5">IMPOSTE SUL REDDITO D'ESERCIZIO</label>
                          <ejs-numerictextbox id="prevImposteReddEserc" v-model="bilancioCocciaActiveData.prevImposteReddEserc"
                                              floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="IMPOSTE SUL REDDITO D'ESERCIZIO"
                                              showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="prevTotaleUscite" class="h5">TOTALE USCITE BILANCIO PREVENTIVO</label>
                          <ejs-numerictextbox id="prevTotaleUscite" v-model="prevTotaleUscite" floatLabelType="Never"
                            cssClass="" format="€ ###.##" placeholder="Totale Uscite" showSpinButton="false"
                            showClearButton="true" :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>DEFICIT BILANCIO PREVENTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title></b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="prevDeficit" class="h5">DEFICIT BILANCIO PREVENTIVO</label>
                          <ejs-numerictextbox id="prevDeficit" v-model="prevDeficit" floatLabelType="Never" cssClass=""
                            format="€ ###.##" placeholder="Deficit" showSpinButton="false" showClearButton="true"
                            :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="BILANCIO COCCIA CONSUNTIVO" @click="tabClicked('tab02')">
              <b-row class="match-height">
                <b-col xl="12" md="12">
                  <h3>&nbsp</h3>
                  <h3>ENTRATE BILANCIO CONSUNTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Entrate</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviBiglProd" class="h5">RICAVI BIGLIETTERIA PRODUZIONI</label>
                          <ejs-numerictextbox id="consRicaviBiglProd" v-model="bilancioCocciaActiveData.consRicaviBiglProd
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI BIGLIETTERIA PRODUZIONI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviBiglCompOsp" class="h5">RICAVI BIGLIETTERIA COMPAGNIE OSPITI</label>
                          <ejs-numerictextbox id="consRicaviBiglCompOsp" v-model="bilancioCocciaActiveData.consRicaviBiglCompOsp
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="RICAVI BIGLIETTERIA COMPAGNIE OSPITI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviCoprodSpett" class="h5">RICAVI PER COPRODUZIONI SPETTACOLI</label>
                          <ejs-numerictextbox id="consRicaviCoprodSpett" v-model="bilancioCocciaActiveData.consRicaviCoprodSpett
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="RICAVI PER COPRODUZIONI SPETTACOLI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviAccademiaCantoDir" class="h5">RICAVI PER ACCADEMIA - CANTO E
                            DIREZIONE</label>
                          <ejs-numerictextbox id="consRicaviAccademiaCantoDir"
                            v-model="bilancioCocciaActiveData.consRicaviAccademiaCantoDir" floatLabelType="Never"
                            cssClass="" format="€ ###.##" placeholder="RICAVI PER ACCADEMIA - CANTO E DIREZIONE"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviPrestServizi" class="h5">RICAVI DA PRESTAZIONI DI SERVIZI</label>
                          <ejs-numerictextbox id="consRicaviPrestServizi" v-model="bilancioCocciaActiveData.consRicaviPrestServizi
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA PRESTAZIONI DI SERVIZI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviSponsor" class="h5">RICAVI DA SPONSOR</label>
                          <ejs-numerictextbox id="consRicaviSponsor" v-model="bilancioCocciaActiveData.consRicaviSponsor
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA SPONSOR"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviProgetti" class="h5">RICAVI DA PROGETTI</label>
                          <ejs-numerictextbox id="consRicaviProgetti" v-model="bilancioCocciaActiveData.consRicaviProgetti
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA PROGETTI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviMinistero" class="h5">RICAVI DA MINISTERO</label>
                          <ejs-numerictextbox id="consRicaviMinistero" v-model="bilancioCocciaActiveData.consRicaviMinistero
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA MINISTERO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviRegPiemonte" class="h5">RICAVI DA REGIONE PIEMONTE</label>
                          <ejs-numerictextbox id="consRicaviRegPiemonte" v-model="bilancioCocciaActiveData.consRicaviRegPiemonte
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA REGIONE PIEMONTE"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviComNovaraOrd" class="h5">RICAVI DA COMUNE DI NOVARA</label>
                          <ejs-numerictextbox id="consRicaviComNovaraOrd" v-model="bilancioCocciaActiveData.consRicaviComNovaraOrd
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA COMUNE DI NOVARA"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviComNovaraExtra" class="h5">RICAVI DA COMUNE DI NOVARA - CONTRIBUTO
                            EXTRA</label>
                          <ejs-numerictextbox id="consRicaviComNovaraExtra" v-model="bilancioCocciaActiveData.consRicaviComNovaraExtra
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="RICAVI DA COMUNE DI NOVARA - CONTRIBUTO EXTRA" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviFondBPM" class="h5">RICAVI DA FONDAZIONE BPM</label>
                          <ejs-numerictextbox id="consRicaviFondBPM" v-model="bilancioCocciaActiveData.consRicaviFondBPM
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA FONDAZIONE BPM"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviFondCRT" class="h5">RICAVI DA FONDAZIONE CRT</label>
                          <ejs-numerictextbox id="consRicaviFondCRT" v-model="bilancioCocciaActiveData.consRicaviFondCRT
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA FONDAZIONE CRT"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRicaviCCIAA" class="h5">RICAVI DA CCIAA</label>
                          <ejs-numerictextbox id="consRicaviCCIAA" v-model="bilancioCocciaActiveData.consRicaviCCIAA
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RICAVI DA CCIAA"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consContrArtBonus" class="h5">CONTRIBUTI ART BONUS</label>
                          <ejs-numerictextbox id="consContrArtBonus" v-model="bilancioCocciaActiveData.consContrArtBonus
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CONTRIBUTI ART BONUS"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consProventiDonazioni" class="h5">PROVENTI DA DONAZIONI</label>
                          <ejs-numerictextbox id="consProventiDonazioni" v-model="bilancioCocciaActiveData.consProventiDonazioni
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="PROVENTI DA DONAZIONI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAffittiAttivi" class="h5">AFFITTI ATTIVI</label>
                          <ejs-numerictextbox id="consAffittiAttivi" v-model="bilancioCocciaActiveData.consAffittiAttivi
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="AFFITTI ATTIVI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>

                        <b-col xl="12" md="12" class="mb-2">
                          <label for="consTotaleEntrate" class="h5">TOTALE ENTRATE BILANCIO CONSUNTIVO</label>
                          <ejs-numerictextbox id="consTotaleEntrate" v-model="consTotaleEntrate" floatLabelType="Never"
                            cssClass="" format="€ ###.##" placeholder="Totale Entrate" showSpinButton="false"
                            showClearButton="true" :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>USCITE BILANCIO CONSUNTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Uscite</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAcquistiMatScene" class="h5">ACQUISTI MATERIALI PER SCENE</label>
                          <ejs-numerictextbox id="consAcquistiMatScene" v-model="bilancioCocciaActiveData.consAcquistiMatScene
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ACQUISTI MATERIALI PER SCENE"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAcquistiMatConsumo" class="h5">ACQUISTI MATERIALE DI CONSUMO</label>
                          <ejs-numerictextbox id="consAcquistiMatConsumo" v-model="bilancioCocciaActiveData.consAcquistiMatConsumo
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ACQUISTI MATERIALE DI CONSUMO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consDispositiviProtCovid" class="h5">DISPOSITIVI DI PROTEZIONE COVID19</label>
                          <ejs-numerictextbox id="consDispositiviProtCovid" v-model="bilancioCocciaActiveData.consDispositiviProtCovid
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="DISPOSITIVI DI PROTEZIONE COVID19" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAttrInf516Eur" class="h5">ATTREZZATURA inf. 516 EURO DA NON AMM.RE</label>
                          <ejs-numerictextbox id="consAttrInf516Eur" v-model="bilancioCocciaActiveData.consAttrInf516Eur
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="ATTREZZATURA inf. 516 EURO DA NON AMM.RE" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCellulariDed80inf516Eur" class="h5">ACQUISTO CELLULARI DED 80% inf. 516 € DA
                            NON AMM.RE</label>
                          <ejs-numerictextbox id="consCellulariDed80inf516Eur" v-model="bilancioCocciaActiveData.consCellulariDed80inf516Eur
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="ACQUISTO CELLULARI DED 80% inf. 516 € DA NON AMM.RE" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCarbLubrMezziTrasp" class="h5">CARBURANTI E LUBRIFICANTI PER MEZZI DI
                            TRASPORTO</label>
                          <ejs-numerictextbox id="consCarbLubrMezziTrasp" v-model="bilancioCocciaActiveData.consCarbLubrMezziTrasp
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="CARBURANTI E LUBRIFICANTI PER MEZZI DI TRASPORTO" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAcquistoMatPubbl" class="h5">ACQUISTO MATERIALE PUBBLICITARIO</label>
                          <ejs-numerictextbox id="consAcquistoMatPubbl" v-model="bilancioCocciaActiveData.consAcquistoMatPubbl
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ACQUISTO MATERIALE PUBBLICITARIO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCancelleria" class="h5">CANCELLERIA</label>
                          <ejs-numerictextbox id="consCancelleria" v-model="bilancioCocciaActiveData.consCancelleria
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CANCELLERIA"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consMatPulizia" class="h5">MATERIALE DI PULIZIA</label>
                          <ejs-numerictextbox id="consMatPulizia" v-model="bilancioCocciaActiveData.consMatPulizia
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="MATERIALE DI PULIZIA"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAcquistoFarmaci" class="h5">ACQUISTO DI FARMACI</label>
                          <ejs-numerictextbox id="consAcquistoFarmaci" v-model="bilancioCocciaActiveData.consAcquistoFarmaci
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ACQUISTO DI FARMACI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSpeseVittoAlloggio" class="h5">SPESE VITTO, ALLOGGIO</label>
                          <ejs-numerictextbox id="consSpeseVittoAlloggio" v-model="bilancioCocciaActiveData.consSpeseVittoAlloggio
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SPESE VITTO, ALLOGGIO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSpeseViaggioTrasfertaDip" class="h5">SPESE DI VIAGGIO E TRASFERTA
                            DIPENDENTI</label>
                          <ejs-numerictextbox id="consSpeseViaggioTrasfertaDip" v-model="bilancioCocciaActiveData.consSpeseViaggioTrasfertaDip
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="SPESE DI VIAGGIO E TRASFERTA DIPENDENTI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consOpereServiziGenerDip" class="h5">OPERE E SERVIZI PER LA GENERALITA' DEI
                            DIPENDENTI</label>
                          <ejs-numerictextbox id="consOpereServiziGenerDip" v-model="bilancioCocciaActiveData.consOpereServiziGenerDip
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="OPERE E SERVIZI PER LA GENERALITA' DEI DIPENDENTI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consPedaggiAutostr" class="h5">PEDAGGI AUTOSTRADALI</label>
                          <ejs-numerictextbox id="consPedaggiAutostr"
                            v-model="bilancioCocciaActiveData.consPedaggiAutostr" floatLabelType="Never" cssClass=""
                            format="€ ###.##" placeholder="PEDAGGI AUTOSTRADALI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSpesePubblicita" class="h5">SPESE DI PUBBLICITA'</label>
                          <ejs-numerictextbox id="consSpesePubblicita" v-model="bilancioCocciaActiveData.consSpesePubblicita
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SPESE DI PUBBLICITA'"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consEnergiaElettrica" class="h5">ENERGIA ELETTRICA</label>
                          <ejs-numerictextbox id="consEnergiaElettrica" v-model="bilancioCocciaActiveData.consEnergiaElettrica
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ENERGIA ELETTRICA"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consConsulenzeTecniche" class="h5">CONSULENZE TECNICHE</label>
                          <ejs-numerictextbox id="consConsulenzeTecniche" v-model="bilancioCocciaActiveData.consConsulenzeTecniche
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CONSULENZE TECNICHE"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consServiziVigilAntinc" class="h5">SERVIZI VIGILANZA ANTINCENDIO</label>
                          <ejs-numerictextbox id="consServiziVigilAntinc" v-model="bilancioCocciaActiveData.consServiziVigilAntinc
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SERVIZI VIGILANZA ANTINCENDIO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consManutRiparAutomezzi" class="h5">MANUTENZIONI E RIPARAZIONI AUTOMEZZI</label>
                          <ejs-numerictextbox id="consManutRiparAutomezzi" v-model="bilancioCocciaActiveData.consManutRiparAutomezzi
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="MANUTENZIONI E RIPARAZIONI AUTOMEZZI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSpeseRecupCrediti" class="h5">SPESE PER RECUPERO CREDITI</label>
                          <ejs-numerictextbox id="consSpeseRecupCrediti" v-model="bilancioCocciaActiveData.consSpeseRecupCrediti
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SPESE PER RECUPERO CREDITI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAssicDiverseNonObbl" class="h5">ASSICURAZIONI DIVERSE NON OBBLIGATORIE</label>
                          <ejs-numerictextbox id="consAssicDiverseNonObbl" v-model="bilancioCocciaActiveData.consAssicDiverseNonObbl
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="ASSICURAZIONI DIVERSE NON OBBLIGATORIE" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSpeseServPostali" class="h5">SPESE PER SERVIZI POSTALI</label>
                          <ejs-numerictextbox id="consSpeseServPostali" v-model="bilancioCocciaActiveData.consSpeseServPostali
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SPESE PER SERVIZI POSTALI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consServPulizia" class="h5">SERVIZI DI PULIZIA</label>
                          <ejs-numerictextbox id="consServPulizia" v-model="bilancioCocciaActiveData.consServPulizia"
                            floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SERVIZI DI PULIZIA"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAcqua" class="h5">ACQUA</label>
                          <ejs-numerictextbox id="consAcqua" v-model="bilancioCocciaActiveData.consAcqua
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ACQUA" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSpeseFormazAntincPrSocc" class="h5">SPESE FORMAZIONE ANTINCENDIO E PRONTO
                            SOCCORSO</label>
                          <ejs-numerictextbox id="consSpeseFormazAntincPrSocc" v-model="bilancioCocciaActiveData.consSpeseFormazAntincPrSocc
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="SPESE FORMAZIONE ANTINCENDIO E PRONTO SOCCORSO" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consServiziDiTerzi" class="h5">SERVIZI DI TERZI (SERVIZI DI SALA, SEGRETARIATO,
                            FACCHINAGGIO)</label>
                          <ejs-numerictextbox id="consServiziDiTerzi" v-model="bilancioCocciaActiveData.consServiziDiTerzi
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="SERVIZI DI TERZI (SERVIZI DI SALA, SEGRETARIATO, FACCHINAGGIO)"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consConsulAmmLegali" class="h5">CONSULENZE AMMINISTRATIVE E LEGALI</label>
                          <ejs-numerictextbox id="consConsulAmmLegali" v-model="bilancioCocciaActiveData.consConsulAmmLegali
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="CONSULENZE AMMINISTRATIVE E LEGALI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consTelefoniche" class="h5">TELEFONICHE </label>
                          <ejs-numerictextbox id="consTelefoniche" v-model="bilancioCocciaActiveData.consTelefoniche
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="TELEFONICHE "
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSpeseElaborPaghe" class="h5">SPESE ELABORAZIONE PAGHE</label>
                          <ejs-numerictextbox id="consSpeseElaborPaghe" v-model="bilancioCocciaActiveData.consSpeseElaborPaghe
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SPESE ELABORAZIONE PAGHE"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consManutRiparazioni" class="h5">MANUTENZIONI E RIPARAZIONI</label>
                          <ejs-numerictextbox id="consManutRiparazioni" v-model="bilancioCocciaActiveData.consManutRiparazioni
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="MANUTENZIONI E RIPARAZIONI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consManutAContratto" class="h5">MANUTENZIONI A CONTRATTO</label>
                          <ejs-numerictextbox id="consManutAContratto" v-model="bilancioCocciaActiveData.consManutAContratto
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="MANUTENZIONI A CONTRATTO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRiscaldamento" class="h5">RISCALDAMENTO</label>
                          <ejs-numerictextbox id="consRiscaldamento" v-model="bilancioCocciaActiveData.consRiscaldamento
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="RISCALDAMENTO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consServBancari" class="h5">SERVIZI BANCARI</label>
                          <ejs-numerictextbox id="consServBancari" v-model="bilancioCocciaActiveData.consServBancari"
                            floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SERVIZI BANCARI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCostiServiziRifiuti" class="h5">COSTI PER SERVIZI SU RIFIUTI</label>
                          <ejs-numerictextbox id="consCostiServiziRifiuti"
                            v-model="bilancioCocciaActiveData.consCostiServiziRifiuti" floatLabelType="Never"
                            cssClass="" format="€ ###.##" placeholder="COSTI PER SERVIZI SU RIFIUTI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAssicDiverseObbl" class="h5">ASSICURAZIONI DIVERSE OBBLIGATORIE</label>
                          <ejs-numerictextbox id="consAssicDiverseObbl" v-model="bilancioCocciaActiveData.consAssicDiverseObbl
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="ASSICURAZIONI DIVERSE OBBLIGATORIE" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCanoniAssistSoftware" class="h5">CANONI ASSISTENZA SOFTWARE</label>
                          <ejs-numerictextbox id="consCanoniAssistSoftware" v-model="bilancioCocciaActiveData.consCanoniAssistSoftware
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CANONI ASSISTENZA SOFTWARE"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consServiziInternet" class="h5">SERVIZI RELATIVI A INTERNET</label>
                          <ejs-numerictextbox id="consServiziInternet" v-model="bilancioCocciaActiveData.consServiziInternet
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SERVIZI RELATIVI A INTERNET"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consViaggioTrasfCollaboratori" class="h5">VIAGGIO E TRASFERTE
                            COLLABORATORI</label>
                          <ejs-numerictextbox id="consViaggioTrasfCollaboratori" v-model="bilancioCocciaActiveData.consViaggioTrasfCollaboratori
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="VIAGGIO E TRASFERTE COLLABORATORI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consScene" class="h5">SCENE</label>
                          <ejs-numerictextbox id="consScene" v-model="bilancioCocciaActiveData.consScene
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SCENE" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCostumi" class="h5">COSTUMI</label>
                          <ejs-numerictextbox id="consCostumi" v-model="bilancioCocciaActiveData.consCostumi
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="COSTUMI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCoro" class="h5">CORO</label>
                          <ejs-numerictextbox id="consCoro" v-model="bilancioCocciaActiveData.consCoro
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CORO" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consOrchestra" class="h5">ORCHESTRA</label>
                          <ejs-numerictextbox id="consOrchestra" v-model="bilancioCocciaActiveData.consOrchestra"
                            floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ORCHESTRA"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consTrasporti" class="h5">TRASPORTI</label>
                          <ejs-numerictextbox id="consTrasporti" v-model="bilancioCocciaActiveData.consTrasporti
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="TRASPORTI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCollabProfessTecnici" class="h5">COLLABORATORI PROFESSIONISTI TECNICI</label>
                          <ejs-numerictextbox id="consCollabProfessTecnici" v-model="bilancioCocciaActiveData.consCollabProfessTecnici
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="COLLABORATORI PROFESSIONISTI TECNICI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCollabArtistici" class="h5">COLLABORATORI ARTISTICI</label>
                          <ejs-numerictextbox id="consCollabArtistici" v-model="bilancioCocciaActiveData.consCollabArtistici
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="COLLABORATORI ARTISTICI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAllestimenti" class="h5">ALLESTIMENTI</label>
                          <ejs-numerictextbox id="consAllestimenti" v-model="bilancioCocciaActiveData.consAllestimenti
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ALLESTIMENTI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consNoloPartiture" class="h5">NOLO PARTITURE</label>
                          <ejs-numerictextbox id="consNoloPartiture" v-model="bilancioCocciaActiveData.consNoloPartiture
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="NOLO PARTITURE"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consVittoAlloggioArtisti" class="h5">VITTO E ALLOGGIO ARTISTI</label>
                          <ejs-numerictextbox id="consVittoAlloggioArtisti" v-model="bilancioCocciaActiveData.consVittoAlloggioArtisti
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="VITTO E ALLOGGIO ARTISTI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCachetCompOspiti1" class="h5">CACHET COMPAGNIE OSPITI 1</label>
                          <ejs-numerictextbox id="consCachetCompOspiti1" v-model="bilancioCocciaActiveData.consCachetCompOspiti1
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CACHET COMPAGNIE OSPITI 1"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCoproduzioni" class="h5">COPRODUZIONI</label>
                          <ejs-numerictextbox id="consCoproduzioni" v-model="bilancioCocciaActiveData.consCoproduzioni
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="COPRODUZIONI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCachetCompOspiti2" class="h5">CACHET COMPAGNIE OSPITI 2</label>
                          <ejs-numerictextbox id="consCachetCompOspiti2" v-model="bilancioCocciaActiveData.consCachetCompOspiti2
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CACHET COMPAGNIE OSPITI 2"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consDocenti" class="h5">DOCENTI</label>
                          <ejs-numerictextbox id="consDocenti" v-model="bilancioCocciaActiveData.consDocenti
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="DOCENTI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCollArtisticiAMO" class="h5">COLL ARTISTICI AMO</label>
                          <ejs-numerictextbox id="consCollArtisticiAMO" v-model="bilancioCocciaActiveData.consCollArtisticiAMO
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="COLL ARTISTICI AMO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consServDigitalizz" class="h5">SERVIZI DI DIGITALIZZAZIONE</label>
                          <ejs-numerictextbox id="consServDigitalizz" v-model="bilancioCocciaActiveData.consServDigitalizz
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SERVIZI DI DIGITALIZZAZIONE"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consNoleggioSceneCostumi" class="h5">NOLEGGIO SCENE E COSTUMI</label>
                          <ejs-numerictextbox id="consNoleggioSceneCostumi" v-model="bilancioCocciaActiveData.consNoleggioSceneCostumi
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="NOLEGGIO SCENE E COSTUMI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consNoleggioMatTecnico" class="h5">NOLEGGIO MATERIALE TECNICO</label>
                          <ejs-numerictextbox id="consNoleggioMatTecnico" v-model="bilancioCocciaActiveData.consNoleggioMatTecnico
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="NOLEGGIO MATERIALE TECNICO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAffittiLocPassImmob" class="h5">AFFITTI E LOCAZIONI PASSIVE IMMOBILI</label>
                          <ejs-numerictextbox id="consAffittiLocPassImmob" v-model="bilancioCocciaActiveData.consAffittiLocPassImmob
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="AFFITTI E LOCAZIONI PASSIVE IMMOBILI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCanoniNolMacchUff" class="h5">CANONI NOLEGGIO MACCHINE D'UFFICIO</label>
                          <ejs-numerictextbox id="consCanoniNolMacchUff" v-model="bilancioCocciaActiveData.consCanoniNolMacchUff
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="CANONI NOLEGGIO MACCHINE D'UFFICIO" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consNoleggioAutomezzi" class="h5">NOLEGGIO AUTOMEZZI</label>
                          <ejs-numerictextbox id="consNoleggioAutomezzi" v-model="bilancioCocciaActiveData.consNoleggioAutomezzi
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="NOLEGGIO AUTOMEZZI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAggSWLicUso" class="h5">AGGIORNAMENTO SOFTWARE E LICENZE D'USO</label>
                          <ejs-numerictextbox id="consAggSWLicUso" v-model="bilancioCocciaActiveData.consAggSWLicUso
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="AGGIORNAMENTO SOFTWARE E LICENZE D'USO" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAffittiLocazioni" class="h5">AFFITTI E LOCAZIONI</label>
                          <ejs-numerictextbox id="consAffittiLocazioni" v-model="bilancioCocciaActiveData.consAffittiLocazioni
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="AFFITTI E LOCAZIONI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consLeasingFinanziario" class="h5">LEASING FINANZIARIO (AMPLIAMENTO RETE WIFI, PC
                            UFFICI, ETC.)</label>
                          <ejs-numerictextbox id="consLeasingFinanziario" v-model="bilancioCocciaActiveData.consLeasingFinanziario
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="LEASING FINANZIARIO (AMPLIAMENTO RETE WIFI, PC UFFICI, ETC.)"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRoyaltiesDirAutBrevetti" class="h5">ROYALTIES, DIRITTI D'AUTORE E
                            BREVETTI</label>
                          <ejs-numerictextbox id="consRoyaltiesDirAutBrevetti" v-model="bilancioCocciaActiveData.consRoyaltiesDirAutBrevetti
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="ROYALTIES, DIRITTI D'AUTORE E BREVETTI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSalariStipendi" class="h5">SALARI E STIPENDI</label>
                          <ejs-numerictextbox id="consSalariStipendi" v-model="bilancioCocciaActiveData.consSalariStipendi
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SALARI E STIPENDI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consContrPrevidImpiegTecnici" class="h5">CONTRIBUTI PREVIDENZIALI IMPIEGATI
                            TECNICI</label>
                          <ejs-numerictextbox id="consContrPrevidImpiegTecnici" v-model="bilancioCocciaActiveData.consContrPrevidImpiegTecnici
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="CONTRIBUTI PREVIDENZIALI IMPIEGATI TECNICI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consContribEnpalsArtisti" class="h5">CONTRIBUTI ENPALS ARTISTI</label>
                          <ejs-numerictextbox id="consContribEnpalsArtisti" v-model="bilancioCocciaActiveData.consContribEnpalsArtisti
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CONTRIBUTI ENPALS ARTISTI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consContrInail" class="h5">CONTRIBUTI INAIL</label>
                          <ejs-numerictextbox id="consContrInail" v-model="bilancioCocciaActiveData.consContrInail
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="CONTRIBUTI INAIL"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consOneriSociali" class="h5">ONERI SOCIALI</label>
                          <ejs-numerictextbox id="consOneriSociali" v-model="bilancioCocciaActiveData.consOneriSociali
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ONERI SOCIALI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consTrattamFineRapp" class="h5">TRATTAMENTO DI FINE RAPPORTO</label>
                          <ejs-numerictextbox id="consTrattamFineRapp" v-model="bilancioCocciaActiveData.consTrattamFineRapp
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="TRATTAMENTO DI FINE RAPPORTO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAmmortImmobilizImmat" class="h5">AMMORTAMENTO DELLE IMMOBILIZZAZIONI
                            IMMATERIALI</label>
                          <ejs-numerictextbox id="consAmmortImmobilizImmat" v-model="bilancioCocciaActiveData.consAmmortImmobilizImmat
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="AMMORTAMENTO DELLE IMMOBILIZZAZIONI IMMATERIALI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAmmortBeniMat" class="h5">AMMORTAMENTO BENI MATERIALI</label>
                          <ejs-numerictextbox id="consAmmortBeniMat" v-model="bilancioCocciaActiveData.consAmmortBeniMat
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="AMMORTAMENTO BENI MATERIALI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consBeniOmaggEccOmaggi" class="h5">BENI OMAGGIO E ECCEDENZA OMAGGI</label>
                          <ejs-numerictextbox id="consBeniOmaggEccOmaggi" v-model="bilancioCocciaActiveData.consBeniOmaggEccOmaggi
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="BENI OMAGGIO E ECCEDENZA OMAGGI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consIMU" class="h5">IMU</label>
                          <ejs-numerictextbox id="consIMU" v-model="bilancioCocciaActiveData.consIMU
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="IMU" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consImpostaRegistro" class="h5">IMPOSTA DI REGISTRO</label>
                          <ejs-numerictextbox id="consImpostaRegistro" v-model="bilancioCocciaActiveData.consImpostaRegistro
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="IMPOSTA DI REGISTRO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consTARI" class="h5">TARI</label>
                          <ejs-numerictextbox id="consTARI" v-model="bilancioCocciaActiveData.consTARI
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="TARI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSopravvPassive" class="h5">SOPRAVVENIENZE PASSIVE </label>
                          <ejs-numerictextbox id="consSopravvPassive" v-model="bilancioCocciaActiveData.consSopravvPassive
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SOPRAVVENIENZE PASSIVE "
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consBolliValBollati" class="h5">BOLLI E VALORI BOLLATI</label>
                          <ejs-numerictextbox id="consBolliValBollati" v-model="bilancioCocciaActiveData.consBolliValBollati
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="BOLLI E VALORI BOLLATI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consQuoteAssocContribAssoc" class="h5">QUOTE ASSOCIATIVE/CONTRIBUTI
                            ASSOCIATIVI</label>
                          <ejs-numerictextbox id="consQuoteAssocContribAssoc" v-model="bilancioCocciaActiveData.consQuoteAssocContribAssoc
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="QUOTE ASSOCIATIVE/CONTRIBUTI ASSOCIATIVI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consDirittiSIAE" class="h5">DIRITTI SIAE</label>
                          <ejs-numerictextbox id="consDirittiSIAE" v-model="bilancioCocciaActiveData.consDirittiSIAE
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="DIRITTI SIAE"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSopravvPassEsPrec" class="h5">SOPRAVV PASSIVE ESERC PRECEDENTI</label>
                          <ejs-numerictextbox id="consSopravvPassEsPrec" v-model="bilancioCocciaActiveData.consSopravvPassEsPrec
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="SOPRAVV PASSIVE ESERC PRECEDENTI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSanzTribRavvOpInded" class="h5">SANZIONI TRIBUTARIE DA RAVVED. OPEROSO
                            INDEDUCIBILI</label>
                          <ejs-numerictextbox id="consSanzTribRavvOpInded" v-model="bilancioCocciaActiveData.consSanzTribRavvOpInded
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="SANZIONI TRIBUTARIE DA RAVVED. OPEROSO INDEDUCIBILI" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAltriProvFinanz" class="h5">ALTRI PROVENTI FINANZIARI</label>
                          <ejs-numerictextbox id="consAltriProvFinanz" v-model="bilancioCocciaActiveData.consAltriProvFinanz
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ALTRI PROVENTI FINANZIARI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consOneriBancFinanz" class="h5">ONERI BANCARI FINANZIARI</label>
                          <ejs-numerictextbox id="consOneriBancFinanz" v-model="bilancioCocciaActiveData.consOneriBancFinanz
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="ONERI BANCARI FINANZIARI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consInterPassContoCorr" class="h5">INTERESSI PASSIVI DI CONTO CORRENTE</label>
                          <ejs-numerictextbox id="consInterPassContoCorr" v-model="bilancioCocciaActiveData.consInterPassContoCorr
                  " floatLabelType="Never" cssClass="" format="€ ###.##"
                            placeholder="INTERESSI PASSIVI DI CONTO CORRENTE" showSpinButton="false"
                            showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consInterPassiviMutui" class="h5">INTERESSI PASSIVI SU MUTUI</label>
                          <ejs-numerictextbox id="consInterPassiviMutui" v-model="bilancioCocciaActiveData.consInterPassiviMutui
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="INTERESSI PASSIVI SU MUTUI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consInterPassiviMora" class="h5">INTERESSI PASSIVI DI MORA</label>
                          <ejs-numerictextbox id="consInterPassiviMora" v-model="bilancioCocciaActiveData.consInterPassiviMora
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="INTERESSI PASSIVI DI MORA"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consProvOneriFinanz" class="h5">PROVENTI E ONERI FINANZIARI</label>
                          <ejs-numerictextbox id="consProvOneriFinanz" v-model="bilancioCocciaActiveData.consProvOneriFinanz
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="PROVENTI E ONERI FINANZIARI"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consImposteReddEserc" class="h5">IMPOSTE SUL REDDITO D'ESERCIZIO</label>
                          <ejs-numerictextbox id="consImposteReddEserc" v-model="bilancioCocciaActiveData.consImposteReddEserc
                  " floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="IMPOSTE SUL REDDITO D'ESERCIZIO"
                            showSpinButton="false" showClearButton="true" />
                        </b-col>


                        <b-col xl="12" md="12" class="mb-2">
                          <label for="consTotaleUscite" class="h5">TOTALE USCITE BILANCIO CONSUNTIVO</label>
                          <ejs-numerictextbox id="consTotaleUscite" v-model="consTotaleUscite" floatLabelType="Never"
                            cssClass="" format="€ ###.##" placeholder="Totale Uscite" showSpinButton="false"
                            showClearButton="true" :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>DEFICIT BILANCIO CONSUNTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title></b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="consDeficit" class="h5">DEFICIT BILANCIO CONSUNTIVO</label>
                          <ejs-numerictextbox id="consDeficit" v-model="consDeficit" floatLabelType="Never" cssClass=""
                            format="€ ###.##" placeholder="Deficit" showSpinButton="false" showClearButton="true"
                            :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
      <b-col xl="12" md="12" class="text-right mt-1" v-show="showTabsBilancio">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title></b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <b-row>
              <b-col xl="4" md="4">
                <ejs-button id="creaBilancioCocciaButton" cssClass="e-flat"
                  @click.native="salvaBilancioCocciaButton()">SALVA IL BILANCIO CORRENTE
                </ejs-button>
              </b-col>
              <!-- temporaneamente nascosto
              <b-col xl="4" md="4">
                <ejs-button id="importaVociRegContabiliButton" cssClass="e-flat"
                  @click.native="importaVociRegContabili()">IMPORTA VOCI CONSUNTIVO DA REG. CONTABILI
                </ejs-button>
              </b-col> -->
              <!-- temporaneamente nascosto
              <b-col xl="4" md="4">
                <ejs-button id="exportaVociRegContabiliButton" cssClass="e-flat"
                  @click.native="esportaVociRegContabili()">ESPORTA BILANCIO IN EXCEL
                </ejs-button>
              </b-col> -->
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
  SpinnerPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Aggregate,
  Group,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
Vue.use(SpinnerPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT;
const apibilancioCocciaUrl = "/demo/api/bilanciococcia";
const apibilancioCocciaRicercaUrl = "/demo/api/bilanciococcia/ricercaAnno";
const apiExportBilancioCocciaUrl = "/demo/api/bilanciococcia/export_bilancio_coccia_xls"
const apiImportBilancioCocciaUrl = "/demo/api/bilanciococcia/import_bilancio_coccia"

var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='ragioneSociale'>{{data.ragioneSociale}}</span><span style='margin-right:3em;display:inline-block;'>&nbsp;&nbsp;</span><span class ='partitaIva'>{{data.partitaIva}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {},
  data() {
    return {
      loading: false,
      // per gestione anni
      anniData: [
        { label: "Anno 2019", val: "2019" },
        { label: "Anno 2020", val: "2020" },
        { label: "Anno 2021", val: "2021" },
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
        { label: "Anno 2027", val: "2027" },
        // { label: "Anno 2026", val: "2026" },
      ],
      anniFields: { value: "val", text: "label" },
      anniIndex: -1,
      queryAnni: null,
      annoCorrente: null,

      // gestione elementi nascosti
      nonMostrare: false,
      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: itemVue };
      },

      // generali
      settings: {
        formatoData: "dd-MM-yyyy",
        formatoOra: "HH:mm",
        intervalloOra: 15,
        firstDayOfWeek: 1,
      },
      // bilancioCoccia
      bilancioCocciaFullData: [], // elenco completo dati bilancioCoccia
      bilancioCocciaActiveId: 0, // Id bilancioCoccia attivo (0 se nuovo)
      bilancioCocciaActiveData: {}, // dati completi del bilancioCoccia attivo
      bilancioCocciaSavedData: {}, // dati completi del bilancioCoccia attivo
      bilancioCocciaDefaultData: {}, // dati completi di default per nuovi bilancioCoccia

      // fornitori
      fornitoriList: [],
      fornitoriFields: { text: "ragioneSociale", value: "id" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per bottoneCreazioneBilancio
      showButtonCreateBilancio: false,

      // per tabA
      tabAIndex: null,

      // per showTabsBilancio
      showTabsBilancio: false,
    };
  },
  created() {
    // log
    console.log("Pagina bilancioCoccia Creata");
    // inizializzazione elenchi dal backend
    // chiamate API

    // TODO gestione status 401 con redirect a login
    if (localStorage.getItem("userData") !== null) {
      // bilancioCocciaNazionalità e bilancioCocciaRuoli
      console.log("Recupero elenchi dal backend");

      // bilancioCocciaFullData
      // recupero elenco bilancioCoccia dal backend
      console.log("Recupero elenco bilancioCoccia dal backend");
    } else {
      console.log("Non trovo UserData, prova ancora");
    }
  },
  mounted() {
    // focus su dropAnni
    this.$refs.dropAnni.ej2Instances.focusIn();
  },

  provide: {
    // per grid
    grid: [
      GridToolbar,
      GridSort,
      GridFilter,
      GridEdit,
      ForeignKey,
      Group,
      Aggregate,
    ],
  },
  methods: {
    creaBilancioCocciaButton: function () {
      console.log("Creazione nuovo Bilancio Coccia");

      // salvataggio in caso di new

      this.bilancioCocciaActiveData = { id: 0, anno: this.annoCorrente };

      useJwt
        .post(apibilancioCocciaUrl, this.bilancioCocciaActiveData)
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            this.makeToast(
              "primary",
              "Successo",
              "Creazione del bilancioCoccia"
            );
          }
          console.log(res.status);
          console.log(res.data);
          // mi segno ID elemento appena creato
          this.bilancioCocciaActiveId = res.data.id;
          return this; // restituisci contesto per permettere aggiornamento gridA
        });
      // .then((context) => {
      //   useJwt.get(apibilancioCocciaUrl).then((d) => {
      //     // gestione risposta
      //     console.log("Aggiornamento gridA con l'aggiunta di una scrittura");
      //     console.log(d.data);
      //     context.bilancioCocciaFullData = d.data;
      //     context.bilancioCocciaFullData = [
      //       ...context.bilancioCocciaFullData,
      //     ];
      //   });
      // });

      this.showButtonCreateBilancio = false;
    },
    salvaBilancioCocciaButton: function () {
      console.log("Salvataggio in Edit Bilancio Coccia");

      // salvataggio in caso di edit

      // salvo i field computed
      this.bilancioCocciaActiveData.prevTotaleEntrate =
        this.prevTotaleEntrate;
      this.bilancioCocciaActiveData.prevTotaleUscite = this.prevTotaleUscite;
      this.bilancioCocciaActiveData.prevDeficit = this.prevDeficit;
      this.bilancioCocciaActiveData.consTotaleEntrate =
        this.consTotaleEntrate;
      this.bilancioCocciaActiveData.consTotaleUscite = this.consTotaleUscite;
      this.bilancioCocciaActiveData.consDeficit = this.consDeficit;

      //this.bilancioCocciaActiveData = { id: 0, anno: this.annoCorrente };
      const editUrl = `${apibilancioCocciaUrl}/${this.bilancioCocciaActiveId}`;

      this.bilancioCocciaActiveData['anno'] = this.annoCorrente
      useJwt.patch(editUrl, this.bilancioCocciaActiveData).then((res) => {
        if (res.status == 200 || res.status == 201) {
          this.makeToast(
            "primary",
            "Successo",
            "Modifica del bilancio Coccia eseguita con successo"
          );
        } else {
          this.makeToast(
            "primary",
            "ERRORE",
            "Errore nel salvataggio bilancio Coccia"
          );

        }
        console.log(res.status);
        console.log(res.data);
        // mi segno ID elemento appena creato
        this.bilancioCocciaActiveId = res.data.id;
        return this; // restituisci contesto per permettere aggiornamento gridA
      });
      // .then((context) => {
      //   useJwt.get(apibilancioCocciaUrl).then((d) => {
      //     // gestione risposta
      //     console.log("Aggiornamento gridA con l'aggiunta di una scrittura");
      //     console.log(d.data);
      //     context.bilancioCocciaFullData = d.data;
      //     context.bilancioCocciaFullData = [
      //       ...context.bilancioCocciaFullData,
      //     ];
      //   });
      // });

      this.showButtonCreateBilancio = false;
    },
    importaVociRegContabili: function () {
      const datiDaInviare = {
        anno: this.annoCorrente,
      }

      useJwt.post(apiImportBilancioCocciaUrl, datiDaInviare).then((r) => {
        console.log(r.data)
        this.bilancioCocciaActiveData = r.data
      })
    },
    esportaVociRegContabili: function () {
      this.bilancioCocciaActiveData['anno'] = this.annoCorrente

      useJwt.post(apiExportBilancioCocciaUrl, this.bilancioCocciaActiveData, { responseType: "blob" }).then((r) => {
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "bilancio_coccia_entrate_uscite.xlsx");
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore generazione excel")
      });
    },
    // onAnnoChange
    async onAnnoChange (e) {
      this.loading = true;
      console.log("Recupero elenco bilanci Coccia dal backend");
      const datiDaInviare = {
        anno: this.annoCorrente,
      };
      if (datiDaInviare.anno === null) {
        console.log("Anno non ancora selezionato");
      } else {
        // recupero il bilancio Coccia salvato con quell'anno se esistente
        const r = await useJwt.post(apibilancioCocciaRicercaUrl, datiDaInviare).then((d) => {
          // gestione risposta
          //this.bilancioCocciaActiveData = d.data;
          console.log("Bilancio Coccia collegato:");
          //console.log(this.bilancioCocciaActiveData);
          //console.log(this.bilancioCocciaActiveData.length);
          this.loading = false;
          console.log(d.data)

          if (d.data['error'] == false) {
            this.bilancioCocciaActiveData = d.data;
            this.bilancioCocciaActiveId = d.data.id;
            // abilito tabs e disabilito bottone create
            this.showTabsBilancio = true;
            this.showButtonCreateBilancio = false;
            console.log("bilancioCocciaActiveData");
            console.log(this.bilancioCocciaActiveData);
            console.log(this.bilancioCocciaActiveData.anno);

            // context.bilancioCocciaFullData = d.data;
            // context.bilancioCocciaFullData = [
            //   ...context.bilancioCocciaFullData,
            // ];
            return false
          } else {
            console.log(
              "Non esiste ancora un bilancio Coccia per l'anno selezionato"
            );
            this.bilancioCocciaActiveData = {};
            // disabilito tabs e abilito bottone create
            this.showTabsBilancio = false;
            this.showButtonCreateBilancio = true;
            return true
          }
        });
        if (r) {
          this.makeToast(
            "primary",
            "Attenzione",
            "Bilancio mancante per l'anno selezionato"
          );
        }
      }
    },

    // per click tabs
    tabClicked(args) {
      switch (args) {
        case "tab01":
          console.log("Sei nel primo tab");
          break;
        case "tab02":
          console.log("Sei nel secondo tab");
          break;
        default:
          console.log(args);
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
  computed: {
    hasChanged() {
      // console.log(this.bilancioCocciaActiveData)
      // console.log(this.bilancioCocciaSavedData)
      return Object.keys(this.bilancioCocciaActiveData).some(
        (field) =>
          this.bilancioCocciaActiveData[field] !==
          this.bilancioCocciaSavedData[field]
      );
    },
    prevTotaleEntrate: {
      get: function () {
        if (this.bilancioCocciaActiveData) {
          return (
            this.bilancioCocciaActiveData.prevRicaviBiglProd +
            this.bilancioCocciaActiveData.prevRicaviBiglCompOsp +
            this.bilancioCocciaActiveData.prevRicaviCoprodSpett +
            this.bilancioCocciaActiveData.prevRicaviAccademiaCantoDir +
            this.bilancioCocciaActiveData.prevRicaviPrestServizi +
            this.bilancioCocciaActiveData.prevRicaviSponsor +
            this.bilancioCocciaActiveData.prevRicaviProgetti +
            this.bilancioCocciaActiveData.prevRicaviMinistero +
            this.bilancioCocciaActiveData.prevRicaviRegPiemonte +
            this.bilancioCocciaActiveData.prevRicaviComNovaraOrd +
            this.bilancioCocciaActiveData.prevRicaviComNovaraExtra +
            this.bilancioCocciaActiveData.prevRicaviFondBPM +
            this.bilancioCocciaActiveData.prevRicaviFondCRT +
            this.bilancioCocciaActiveData.prevRicaviCCIAA +
            this.bilancioCocciaActiveData.prevContrArtBonus +
            this.bilancioCocciaActiveData.prevProventiDonazioni+
            this.bilancioCocciaActiveData.prevAffittiAttivi
          );
        } else {
          return 0
        }
      },
      set: function () {
        // non usato
      },
    },
    prevTotaleUscite: {
      get: function () {
        return (
          this.bilancioCocciaActiveData.prevAcquistiMatScene +
          this.bilancioCocciaActiveData.prevAcquistiMatConsumo +
          this.bilancioCocciaActiveData.prevDispositiviProtCovid +
          this.bilancioCocciaActiveData.prevAttrInf516Eur +
          this.bilancioCocciaActiveData.prevCellulariDed80inf516Eur +
          this.bilancioCocciaActiveData.prevCarbLubrMezziTrasp +
          this.bilancioCocciaActiveData.prevAcquistoMatPubbl +
          this.bilancioCocciaActiveData.prevCancelleria +
          this.bilancioCocciaActiveData.prevMatPulizia +
          this.bilancioCocciaActiveData.prevAcquistoFarmaci +
          this.bilancioCocciaActiveData.prevSpeseVittoAlloggio +
          this.bilancioCocciaActiveData.prevSpeseViaggioTrasfertaDip +
          this.bilancioCocciaActiveData.prevOpereServiziGenerDip +
          this.bilancioCocciaActiveData.prevPedaggiAutostr +
          this.bilancioCocciaActiveData.prevSpesePubblicita +
          this.bilancioCocciaActiveData.prevEnergiaElettrica +
          this.bilancioCocciaActiveData.prevConsulenzeTecniche +
          this.bilancioCocciaActiveData.prevServiziVigilAntinc +
          this.bilancioCocciaActiveData.prevManutRiparAutomezzi +
          this.bilancioCocciaActiveData.prevSpeseRecupCrediti +
          this.bilancioCocciaActiveData.prevAssicDiverseNonObbl +
          this.bilancioCocciaActiveData.prevSpeseServPostali +
          this.bilancioCocciaActiveData.prevServPulizia +
          this.bilancioCocciaActiveData.prevAcqua +
          this.bilancioCocciaActiveData.prevSpeseFormazAntincPrSocc +
          this.bilancioCocciaActiveData.prevServiziDiTerzi +
          this.bilancioCocciaActiveData.prevConsulAmmLegali +
          this.bilancioCocciaActiveData.prevTelefoniche +
          this.bilancioCocciaActiveData.prevSpeseElaborPaghe +
          this.bilancioCocciaActiveData.prevManutRiparazioni +
          this.bilancioCocciaActiveData.prevManutAContratto +
          this.bilancioCocciaActiveData.prevRiscaldamento +
          this.bilancioCocciaActiveData.prevServBancari +
          this.bilancioCocciaActiveData.prevCostiServiziRifiuti +
          this.bilancioCocciaActiveData.prevAssicDiverseObbl +
          this.bilancioCocciaActiveData.prevCanoniAssistSoftware +
          this.bilancioCocciaActiveData.prevServiziInternet +
          this.bilancioCocciaActiveData.prevViaggioTrasfCollaboratori +
          this.bilancioCocciaActiveData.prevScene +
          this.bilancioCocciaActiveData.prevCostumi +
          this.bilancioCocciaActiveData.prevCoro +
          this.bilancioCocciaActiveData.prevOrchestra +
          this.bilancioCocciaActiveData.prevTrasporti +
          this.bilancioCocciaActiveData.prevCollabProfessTecnici +
          this.bilancioCocciaActiveData.prevCollabArtistici +
          this.bilancioCocciaActiveData.prevAllestimenti +
          this.bilancioCocciaActiveData.prevNoloPartiture +
          this.bilancioCocciaActiveData.prevVittoAlloggioArtisti +
          this.bilancioCocciaActiveData.prevCachetCompOspiti1 +
          this.bilancioCocciaActiveData.prevCoproduzioni +
          this.bilancioCocciaActiveData.prevCachetCompOspiti2 +
          this.bilancioCocciaActiveData.prevDocenti +
          this.bilancioCocciaActiveData.prevCollArtisticiAMO +
          this.bilancioCocciaActiveData.prevServDigitalizz +
          this.bilancioCocciaActiveData.prevNoleggioSceneCostumi +
          this.bilancioCocciaActiveData.prevNoleggioMatTecnico +
          this.bilancioCocciaActiveData.prevAffittiLocPassImmob +
          this.bilancioCocciaActiveData.prevCanoniNolMacchUff +
          this.bilancioCocciaActiveData.prevNoleggioAutomezzi +
          this.bilancioCocciaActiveData.prevAggSWLicUso +
          this.bilancioCocciaActiveData.prevAffittiLocazioni +
          this.bilancioCocciaActiveData.prevLeasingFinanziario +
          this.bilancioCocciaActiveData.prevRoyaltiesDirAutBrevetti +
          this.bilancioCocciaActiveData.prevSalariStipendi +
          this.bilancioCocciaActiveData.prevContrPrevidImpiegTecnici +
          this.bilancioCocciaActiveData.prevContribEnpalsArtisti +
          this.bilancioCocciaActiveData.prevContrInail +
          this.bilancioCocciaActiveData.prevOneriSociali +
          this.bilancioCocciaActiveData.prevTrattamFineRapp +
          this.bilancioCocciaActiveData.prevAmmortImmobilizImmat +
          this.bilancioCocciaActiveData.prevAmmortBeniMat +
          this.bilancioCocciaActiveData.prevBeniOmaggEccOmaggi +
          this.bilancioCocciaActiveData.prevIMU +
          this.bilancioCocciaActiveData.prevImpostaRegistro +
          this.bilancioCocciaActiveData.prevTARI +
          this.bilancioCocciaActiveData.prevSopravvPassive +
          this.bilancioCocciaActiveData.prevBolliValBollati +
          this.bilancioCocciaActiveData.prevQuoteAssocContribAssoc +
          this.bilancioCocciaActiveData.prevDirittiSIAE +
          this.bilancioCocciaActiveData.prevSopravvPassEsPrec +
          this.bilancioCocciaActiveData.prevSanzTribRavvOpInded +
          this.bilancioCocciaActiveData.prevAltriProvFinanz +
          this.bilancioCocciaActiveData.prevOneriBancFinanz +
          this.bilancioCocciaActiveData.prevInterPassContoCorr +
          this.bilancioCocciaActiveData.prevInterPassiviMutui +
          this.bilancioCocciaActiveData.prevInterPassiviMora +
          this.bilancioCocciaActiveData.prevProvOneriFinanz +
          this.bilancioCocciaActiveData.prevImposteReddEserc

        );
      },
      set: function () {
        // not usato
      },
    },
    prevDeficit: {
      get: function () {
        return this.prevTotaleUscite - this.prevTotaleEntrate;
      },
      set: function () {
        // non usato
      },
    },
    consTotaleEntrate: {
      get: function () {
        return (
          this.bilancioCocciaActiveData.consRicaviBiglProd +
          this.bilancioCocciaActiveData.consRicaviBiglCompOsp +
          this.bilancioCocciaActiveData.consRicaviCoprodSpett +
          this.bilancioCocciaActiveData.consRicaviAccademiaCantoDir +
          this.bilancioCocciaActiveData.consRicaviPrestServizi +
          this.bilancioCocciaActiveData.consRicaviSponsor +
          this.bilancioCocciaActiveData.consRicaviProgetti +
          this.bilancioCocciaActiveData.consRicaviMinistero +
          this.bilancioCocciaActiveData.consRicaviRegPiemonte +
          this.bilancioCocciaActiveData.consRicaviComNovaraOrd +
          this.bilancioCocciaActiveData.consRicaviComNovaraExtra +
          this.bilancioCocciaActiveData.consRicaviFondBPM +
          this.bilancioCocciaActiveData.consRicaviFondCRT +
          this.bilancioCocciaActiveData.consRicaviCCIAA +
          this.bilancioCocciaActiveData.consContrArtBonus +
          this.bilancioCocciaActiveData.consProventiDonazioni+
          this.bilancioCocciaActiveData.consAffittiAttivi
        );
      },
      set: function () {
        // non usato
      },
    },
    consTotaleUscite: {
      get: function () {
        return (
          this.bilancioCocciaActiveData.consAcquistiMatScene +
          this.bilancioCocciaActiveData.consAcquistiMatConsumo +
          this.bilancioCocciaActiveData.consDispositiviProtCovid +
          this.bilancioCocciaActiveData.consAttrInf516Eur +
          this.bilancioCocciaActiveData.consCellulariDed80inf516Eur +
          this.bilancioCocciaActiveData.consCarbLubrMezziTrasp +
          this.bilancioCocciaActiveData.consAcquistoMatPubbl +
          this.bilancioCocciaActiveData.consCancelleria +
          this.bilancioCocciaActiveData.consMatPulizia +
          this.bilancioCocciaActiveData.consAcquistoFarmaci +
          this.bilancioCocciaActiveData.consSpeseVittoAlloggio +
          this.bilancioCocciaActiveData.consSpeseViaggioTrasfertaDip +
          this.bilancioCocciaActiveData.consOpereServiziGenerDip +
          this.bilancioCocciaActiveData.consPedaggiAutostr +
          this.bilancioCocciaActiveData.consSpesePubblicita +
          this.bilancioCocciaActiveData.consEnergiaElettrica +
          this.bilancioCocciaActiveData.consConsulenzeTecniche +
          this.bilancioCocciaActiveData.consServiziVigilAntinc +
          this.bilancioCocciaActiveData.consManutRiparAutomezzi +
          this.bilancioCocciaActiveData.consSpeseRecupCrediti +
          this.bilancioCocciaActiveData.consAssicDiverseNonObbl +
          this.bilancioCocciaActiveData.consSpeseServPostali +
          this.bilancioCocciaActiveData.consServPulizia +
          this.bilancioCocciaActiveData.consAcqua +
          this.bilancioCocciaActiveData.consSpeseFormazAntincPrSocc +
          this.bilancioCocciaActiveData.consServiziDiTerzi +
          this.bilancioCocciaActiveData.consConsulAmmLegali +
          this.bilancioCocciaActiveData.consTelefoniche +
          this.bilancioCocciaActiveData.consSpeseElaborPaghe +
          this.bilancioCocciaActiveData.consManutRiparazioni +
          this.bilancioCocciaActiveData.consManutAContratto +
          this.bilancioCocciaActiveData.consRiscaldamento +
          this.bilancioCocciaActiveData.consServBancari +
          this.bilancioCocciaActiveData.consCostiServiziRifiuti +
          this.bilancioCocciaActiveData.consAssicDiverseObbl +
          this.bilancioCocciaActiveData.consCanoniAssistSoftware +
          this.bilancioCocciaActiveData.consServiziInternet +
          this.bilancioCocciaActiveData.consViaggioTrasfCollaboratori +
          this.bilancioCocciaActiveData.consScene +
          this.bilancioCocciaActiveData.consCostumi +
          this.bilancioCocciaActiveData.consCoro +
          this.bilancioCocciaActiveData.consOrchestra +
          this.bilancioCocciaActiveData.consTrasporti +
          this.bilancioCocciaActiveData.consCollabProfessTecnici +
          this.bilancioCocciaActiveData.consCollabArtistici +
          this.bilancioCocciaActiveData.consAllestimenti +
          this.bilancioCocciaActiveData.consNoloPartiture +
          this.bilancioCocciaActiveData.consVittoAlloggioArtisti +
          this.bilancioCocciaActiveData.consCachetCompOspiti1 +
          this.bilancioCocciaActiveData.consCoproduzioni +
          this.bilancioCocciaActiveData.consCachetCompOspiti2 +
          this.bilancioCocciaActiveData.consDocenti +
          this.bilancioCocciaActiveData.consCollArtisticiAMO +
          this.bilancioCocciaActiveData.consServDigitalizz +
          this.bilancioCocciaActiveData.consNoleggioSceneCostumi +
          this.bilancioCocciaActiveData.consNoleggioMatTecnico +
          this.bilancioCocciaActiveData.consAffittiLocPassImmob +
          this.bilancioCocciaActiveData.consCanoniNolMacchUff +
          this.bilancioCocciaActiveData.consNoleggioAutomezzi +
          this.bilancioCocciaActiveData.consAggSWLicUso +
          this.bilancioCocciaActiveData.consAffittiLocazioni +
          this.bilancioCocciaActiveData.consLeasingFinanziario +
          this.bilancioCocciaActiveData.consRoyaltiesDirAutBrevetti +
          this.bilancioCocciaActiveData.consSalariStipendi +
          this.bilancioCocciaActiveData.consContrPrevidImpiegTecnici +
          this.bilancioCocciaActiveData.consContribEnpalsArtisti +
          this.bilancioCocciaActiveData.consContrInail +
          this.bilancioCocciaActiveData.consOneriSociali +
          this.bilancioCocciaActiveData.consTrattamFineRapp +
          this.bilancioCocciaActiveData.consAmmortImmobilizImmat +
          this.bilancioCocciaActiveData.consAmmortBeniMat +
          this.bilancioCocciaActiveData.consBeniOmaggEccOmaggi +
          this.bilancioCocciaActiveData.consIMU +
          this.bilancioCocciaActiveData.consImpostaRegistro +
          this.bilancioCocciaActiveData.consTARI +
          this.bilancioCocciaActiveData.consSopravvPassive +
          this.bilancioCocciaActiveData.consBolliValBollati +
          this.bilancioCocciaActiveData.consQuoteAssocContribAssoc +
          this.bilancioCocciaActiveData.consDirittiSIAE +
          this.bilancioCocciaActiveData.consSopravvPassEsPrec +
          this.bilancioCocciaActiveData.consSanzTribRavvOpInded +
          this.bilancioCocciaActiveData.consAltriProvFinanz +
          this.bilancioCocciaActiveData.consOneriBancFinanz +
          this.bilancioCocciaActiveData.consInterPassContoCorr +
          this.bilancioCocciaActiveData.consInterPassiviMutui +
          this.bilancioCocciaActiveData.consInterPassiviMora +
          this.bilancioCocciaActiveData.consProvOneriFinanz +
          this.bilancioCocciaActiveData.consImposteReddEserc
        );
      },
      set: function () {
        // not usato
      },
    },
    consDeficit: {
      get: function () {
        return this.consTotaleUscite - this.consTotaleEntrate;
      },
      set: function () {
        // non usato
      },
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
